import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import * as selectors from "../../state-selectors/google-address-verify";

import GoogleAddressItem from "./GoogleAddressItem";

export class GoogleAddressResults extends Component {
  render() {
    const { addressPredictions = [], logoSrc = "/images/powered-by-google.png" } = this.props;
    if (addressPredictions.length > 0) {
      return (
        <div className="google-address-results" id="google-address-results">
          {addressPredictions.map(place => (
            <GoogleAddressItem
              addressPredictions={addressPredictions}
              place={place}
              key={place.placeId}
            />
          ))}
          <div className="google-address-logo-wrap">
            <img
              src={logoSrc}
              className="google-address-logo"
            />
          </div>
        </div>
      );
    } else {
      return null;
    }
  }
}

GoogleAddressResults.propTypes = {
  addressPredictions: PropTypes.arrayOf(
    PropTypes.shape({
      suggestion: PropTypes.string,
      placeId: PropTypes.string,
      active: PropTypes.bool,
      index: PropTypes.number,
      formattedSuggestion: PropTypes.object
    })
  )
};

const mapStateToProps = state => {
  return {
    addressPredictions: selectors.getAddressPredictions(state)
  };
};

export default connect(mapStateToProps)(GoogleAddressResults);
